import { queryOptions } from "@tanstack/react-query";
import { accountClient } from "../client";

/** The second factors of the signed-in user (ADR-151): never a secret or a code, only what there is. */
export const factorsQuery = queryOptions({
  queryKey: ["auth", "factors"],
  queryFn: () => accountClient().listFactors(),
});

/** The open sessions of the signed-in user, this one marked (ADR-162). */
export const sessionsQuery = queryOptions({
  queryKey: ["auth", "sessions"],
  queryFn: () => accountClient().listSessions(),
});
